<template>
    <div></div>
</template>

<script>
import { mapState } from 'vuex'
import setting from '../services/appsettings'
export default {
  mounted () {
    if (window !== top) top.location.href = location.href
    if (this.$route.query.action === '') {
      window.location.href = this.currentUrl
    } else if (this.$route.query.action === 'create') {
      window.location.href =
        setting.apiUrl + '/Company/Register?rurl=' + window.location.origin
    }
  },
  computed: {
    ...mapState(['currentUrl'])
  }
}
</script>

<style>
</style>
